import { FC } from 'react'
import { SectionEditorialRichTextProps } from '@portfolio/models'
import { Container, PortableText, SectionWrapper } from '@portfolio/components'
import { styled } from '@portfolio/styles'
import { SectionQuote } from '../SectionQuote/SectionQuote'
import { SectionIconWithTextList } from '../SectionIconWithTextList/SectionIconWithTextList'
import { SectionSingleMediaWithDescription } from '../SectionSingleMediaWithDescription/SectionSingleMediaWithDescription'
import { SectionVideoPlayer } from '../SectionVideoPlayer/SectionVideoPlayer'
import { SectionQuoteWithVideo } from '../SectionQuoteWithVideo/SectionQuoteWithVideo'
import { SectionStats } from '../SectionStats/SectionStats'

/**
 *  In this section we use margins (with vw) instead of grid in order to layout the text properly.
 *  This is because grid disables margin collapsing which is used to control spacings between blog sections.
 *  1fr 2fr .25fr => left margin: 30.76vw, right margin: 7.7vw
 */
const StyledContainer = styled(SectionWrapper, {
  '@lg': {
    marginLeft: '30.76vw',
    marginRight: '7.7vw',
  },
})

const PortableTextWrapper = styled(Container, {
  maxWidth: '$richTextWidth',
})

export const SectionEditorialRichText: FC<SectionEditorialRichTextProps> = ({
  content,
}) => {
  if (!content) {
    return null
  }

  return (
    <StyledContainer type="NO_MARGIN">
      <PortableTextWrapper>
        <PortableText
          value={content}
          additionalComponents={{
            types: {
              sectionQuote: (props) => {
                return <SectionQuote {...props.value} />
              },
              sectionIconWithTextList: (props) => {
                return <SectionIconWithTextList {...props.value} />
              },
              sectionSingleMediaWithDescription: (props) => {
                return <SectionSingleMediaWithDescription {...props.value} />
              },
              sectionVideoPlayer: (props) => {
                return <SectionVideoPlayer {...props.value} />
              },
              sectionQuoteWithVideo: (props) => {
                return <SectionQuoteWithVideo {...props.value} />
              },
              sectionStats: (props) => {
                return <SectionStats {...props.value} />
              },
            },
          }}
        />
      </PortableTextWrapper>
    </StyledContainer>
  )
}
